/**
 * SOLID Review
 * S — Strong. One use case: the profile's "send code" for a new address — answering the address it went to.
 * O — Strong. What an address must be is the Domain's.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The decisions and auth-server ports and the session's step, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandEmail, IPayloadEmail } from '../../domain/ports/schemas/AuthMoves';
import type { TPortResult } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { IConfigDepAuth } from './IConfigDepAuth';

/** The profile's "send code" (FE3): no answer step — the screen's line shows the address the code went to. */
export class RequestEmailChangeUseCase implements IUseCase<ICommandEmail, TPortResult<IPayloadEmail>> {
  constructor(private readonly deps: IConfigDepAuth) {}

  async execute(ctx: IContextRequest, command: ICommandEmail): Promise<TPortResult<IPayloadEmail>> {
    const { decisions, step, auth } = this.deps;
    const plan = await step.run(ctx, (input) => decisions.planEmailChange(ctx, input, command));
    if (!plan.success) return plan;
    const sent = await auth.requestEmailChange(ctx, plan.value);
    if (!sent.success) return sent;
    return { success: true, value: plan.value };
  }
}
